import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=74d3b638&"
import script from "./dictionary.vue?vue&type=script&lang=js&"
export * from "./dictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports